import api from '@shared/services/api';
import Profile from '@client/domain/profile';
import { ExchangeAccount } from '@shared/domain/account';

export const getProfile = (): Promise<Profile> => api.get('v1/me');

export const getAccounts = (): Promise<ExchangeAccount[]> => api.get('v1/me/accounts');
